<script setup>
import RewardCard from '@/components/RewardCard.vue'
import {computed} from 'vue'
import {useGlobalStore} from '@/store'

const globalStore = useGlobalStore()
const rewards = computed(() => {
  return globalStore.stepThree.rewards ? globalStore.stepThree.rewards : null
})
const manualRewards = computed(() => {
  return globalStore.stepThree.manualRewards ? globalStore.stepThree.manualRewards : null
})
const detailUrl = globalStore.detailPageUrl

const selectReward = (index, isManualReward) => {
  if (isManualReward) {
    rewards.value.forEach((reward) => {
      reward.selected = false
    })
    manualRewards.value.forEach((reward, i) => {
      reward.selected = i === index
    })
  } else {
    rewards.value.forEach((reward, i) => {
      reward.selected = i === index
    })
    manualRewards.value.forEach((reward) => {
      reward.selected = false
    })
  }
}

</script>

<template>
  <div class="form-view--step">
    <div class="form-view--step-header">
      <h2>{{ $t('stepThree.title') }}</h2>
      <span>{{ $t('stepThree.description') }}</span>
    </div>
    <div class="form-view--step-content form-view--step-content-rewards-wrapper">
      <div v-for="(reward, index) in rewards" :key="index">
        <RewardCard @click="selectReward(index, false)" :reward="reward" :detail-page-url="detailUrl" />
      </div>
      <div v-for="(reward, index) in manualRewards" :key="index">
        <RewardCard @click="selectReward(index, true)" :reward="reward" :is-manual-reward="true" />
      </div>
    </div>
  </div>
</template>

